import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { AbstractTrafficDataSource } from '@types-custom/models/ui/modal-traffic-model';
import { BehaviorSubject, forkJoin, map, Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TrafficApiService implements AbstractTrafficDataSource {
  collectionMapTrafficSR: BehaviorSubject<any> = new BehaviorSubject<any>({});
  aCollectionMapTrafficSR = this.collectionMapTrafficSR.value;

  infoTraffic = {} as any;
  colorsSpeed = [
    { id: 0, color: 'red' },
    { id: 10, color: 'yellow' },
    { id: 20, color: '#00C479' },
  ];

  constructor(
    private httpClient: HttpClient,
    @Inject('environment') private environment: any
  ) { }

  public getLastMeasurements(geometryId: string): Observable<any> {
    return this.httpClient.get<any[]>(
      `${this.environment.trafficUrl}/traffic-history/last-measurements/${geometryId}`
    );
  }

  public getGeoTraffic(): Observable<any[]> {
    return this.httpClient.get<any[]>(
      `${this.environment.trafficUrl}/traffic-geom/format-geo-json`
    );
  }

  public getTrafficSpeedRange(tid: string): Observable<any[]> {
    return this.httpClient.get<any[]>(
      `${this.environment.trafficUrl}/traffic-history/speed-range/${tid}`
    );
  }

  public getTrafficHistory(): Observable<any[]> {
    return this.httpClient.get<any[]>(
      'assets/mock/traffic-history.json'
    );
  }

  public getTravelTimesAvg(): Observable<any[]> {
    return this.httpClient.get<any[]>(
      'assets/mock/travell-times-avg-traffic.json'
    );
  }

  public getDataGraphicHistory(): Observable<any[]> {
    return (
      this.httpClient
        // .get<any>(url)
        .get<any[]>('/assets/mock/traveltime-history.json')
    );
  }

  // public getTrafficMapper(apiObj: any) {
  //   const { geoTraffic } = apiObj;
  //   geoTraffic['features'].map((section: any) => {
  //     section['properties']['concordanceIndex'] =
  //         section['properties']['concordanceIndex'] > 100
  //           ? 100 - section['properties']['concordanceIndex']
  //           : section['properties']['concordanceIndex'];
  //   });

  //   return geoTraffic;
  // }

  public getTrafficMapper(apiObj: any): any {
    const { geoTraffic } = apiObj;

    geoTraffic.features.forEach((section: any) => {
      const cin = section.properties.concordanceIndex;
      section.properties.concordanceIndex = cin > 100 ? 100 - cin : cin;
    });

    return geoTraffic;
  }

}
